import Vue from 'vue'
import Router from 'vue-router'
// import route from './router.js'
// var router = new Router({
//     routes: route
// })
import HelloWorld from '@/components/Home'
import Technology from '@/components/Technology'
import Product from '@/components/Product'
import About from '@/components/About'
import indexa from '@/components/indexa'
import Cooperation from '@/components/Cooperation'
import Journalism from '@/components/Journalism'
import KYLFD from '@/components/Product/KYLFD'//商用车主动安全设备
import polarisTripREC from '@/components/Product/polarisTripREC'//北极星智能行车记录仪
import KYJLY from '@/components/Product/KYJLY'//主动安全智能记录仪
import KYHSJ from '@/components/Product/KYHSJ'//主动安全智能后视镜
import HDashcam from '@/components/Product/HDashcam'//高清行车记录仪
import intelligent from '@/components/Product/intelligent'//智能车载核心板
import AIBOX from '@/components/Product/AIBOX'//AIBOX
import generalSDK from '@/components/Product/generalSDK'//标准版ADAS SDK
import professSdk from '@/components/Product/professSdk'//标准版ADAS SDK
import installedADAS from '@/components/Product/installedADAS'//前装ADAS
import installedDMS from '@/components/Product/installedDMS'//前装DMS
import YKYVehicles from '@/components/Product/YKYVehicles'//车辆管理平台
import Dashcam from '@/components/Product/Dashcam'//车辆管理平台

//阻止重复点击报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)

}
Vue.use(Router)
// Vue.use(VueRouter)
// export default router
export default new Router({
    // mode:"history",
    routes: [{
            path: '/',
            name: 'Home',
            component: HelloWorld
        },
        {
            path: '/Technology',
            name: 'Technology',
            component: Technology
        },
        {
            path: '/Product',
            name: 'Product',
            component: Product
        },
        {
            path: '/About',
            name: 'About',
            component: About
        },
        {
            path: '/Journalism',
            name: 'Journalism',
            component: Journalism
        },
        {
            path: '/indexa',
            name: 'indexa',
            component: indexa
        },
        {
            path: '/KYLFD',
            name: 'KYLFD',
            component: KYLFD
        },
        {
            path: '/polarisTripREC',
            name: 'polarisTripREC',
            component: polarisTripREC
        },
        {
            path: '/KYJLY',
            name: 'KYJLY',
            component: KYJLY
        },
        {
            path: '/KYHSJ',
            name: 'KYHSJ',
            component: KYHSJ
        },
        {
            path: '/HDashcam',
            name: 'HDashcam',
            component: HDashcam
        },
        {
            path: '/intelligent',
            name: 'intelligent',
            component: intelligent
        },
        {
            path: '/AIBOX',
            name: 'AIBOX',
            component: AIBOX
        },
        {
            path: '/generalSDK',
            name: 'generalSDK',
            component: generalSDK
        },
        {
            path: '/professSdk',
            name: 'professSdk',
            component: professSdk
        },
        {
            path: '/installedADAS',
            name: 'installedADAS',
            component: installedADAS
        },
        {
            path: '/installedDMS',
            name: 'installedDMS',
            component: installedDMS
        },
        {
            path: '/YKYVehicles',
            name: 'YKYVehicles',
            component: YKYVehicles
        },
        {
            path: '/Dashcam',
            name: 'Dashcam',
            component: Dashcam
        },
        
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js